import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBluetooth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBluetooth"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0009 0.86499L18.5715 8.00711L13.6912 12L18.5715 15.993L10.0009 23.1351V15.0194L5.86023 18.4072L4.59375 16.8593L10.0009 12.4352V11.5648L4.59375 7.14075L5.86023 5.59284L10.0009 8.9807V0.86499ZM12.1121 10.708L12.0009 10.6171V5.13507L15.4304 7.99296L12.1121 10.708ZM12.1121 13.2921L12.0009 13.383V18.865L15.4304 16.0071L12.1121 13.2921Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBluetooth;
